<template>
    <div>
        <div class="mt-4 flex items-center justify-end">
            <div class="flex items-center gap-4">
                <div class="relative ">
                    <button @click="toggleDropdown"
                        class="bg-gray-200 text-gray-700 py-1 px-3 rounded hover:bg-gray-300 transition flex items-center gap-2">
                        Columnas
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-4 h-4">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                        </svg>
                    </button>
                    <div v-if="showDropdown" class="absolute right-0 mt-2 w-48 bg-white border rounded shadow-lg z-10">
                        <label v-for="col in filteredColumnOptions" :key="col.key"
                            class="flex items-center gap-2 px-3 py-2 hover:bg-gray-100">
                            <input type="checkbox" v-model="visibleColumns" :value="col.key" class="rounded"
                                @change="toggleColumn(col.key)">
                            <span class="text-sm">{{ col.label }}</span>
                        </label>
                    </div>
                </div>
                <button @click="forceRefresh" class="text-gray-600 hover:text-blue-600 transition"
                    :class="{ 'animate-spin': loading }" title="Refrescar">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="overflow-x-auto mt-6 border rounded-lg shadow-sm">
            <table class="w-full text-left border-collapse">
                <thead class="bg-gray-100 sticky top-0">
                    <tr class="table-row">
                        <th v-if="isColumnVisible('posicionGlobal')"
                            class="p-3 cursor-pointer font-semibold whitespace-nowrap gap-2 w-20"
                            @click="toggleOrder('posicionGlobal')">
                            <div class="flex items-center justify-start gap-1">
                                Posición
                                <span v-if="order === 'posicionGlobal'" class="inline-block">
                                    <svg v-if="orderDirection === 'ASC'" xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 15l7-7 7 7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span>
                            </div>
                        </th>
                        <th v-if="isColumnVisible('nombre')" class="p-3 font-semibold whitespace-nowrap w-30" gap-2>
                            Nombre
                        </th>
                        <th v-if="isColumnVisible('ranking')"
                            class="p-3 cursor-pointer font-semibold whitespace-nowrap w-20 gap-2"
                            @click="toggleOrder('ranking')">
                            <div class="flex items-center justify-center gap-1">
                                Ranking
                                <span v-if="order === 'ranking'" class="inline-block">
                                    <svg v-if="orderDirection === 'ASC'" xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 15l7-7 7 7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span>
                            </div>
                        </th>
                        <th v-if="isColumnVisible('totalLecturas') && !tipo"
                            class="p-3 cursor-pointer font-semibold whitespace-nowrap w-12 text-center"
                            @click="toggleOrder('totalLecturas')">
                            <div class="flex items-center justify-center gap-1">
                                Lecturas
                                <span v-if="order === 'totalLecturas'" class="inline-block">
                                    <svg v-if="orderDirection === 'ASC'" xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 15l7-7 7 7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span>
                            </div>
                        </th>
                        <th v-if="isColumnVisible('totalEscuchas') && tipo"
                            class="p-3 cursor-pointer font-semibold whitespace-nowrap w-20 text-center"
                            @click="toggleOrder('totalEscuchas')">
                            Escuchas
                            <span v-if="order === 'totalEscuchas'" class="inline-block">
                                <svg v-if="orderDirection === 'ASC'" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4"
                                    fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M5 15l7-7 7 7" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                    viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 9l-7 7-7-7" />
                                </svg>
                            </span>
                        </th>
                        <th v-if="isColumnVisible('totalVotos')"
                            class="p-3 cursor-pointer font-semibold whitespace-nowrap w-20 text-center"
                            @click="toggleOrder('totalVotos')">
                            <div class="flex items-center justify-center gap-1">
                                Votos
                                <span v-if="order === 'totalVotos'" class="inline-block">
                                    <svg v-if="orderDirection === 'ASC'" xmlns="http://www.w3.org/2000/svg"
                                        class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M5 15l7-7 7 7" />
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none"
                                        viewBox="0 0 24 24" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M19 9l-7 7-7-7" />
                                    </svg>
                                </span>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="!loading || data.length">
                    <tr v-for="(item, index) in data" :key="item.idUsuario" :class="{
                        'bg-yellow-50': idUsuario === item.idUsuario,
                        'bg-gray-50': index % 2 === 0 && idUsuario !== item.idUsuario,
                        'bg-white': index % 2 !== 0,
                        'blur-sm': loading
                    }" class="table-row">
                        <td v-if="isColumnVisible('posicionGlobal')" class="p-3 w-20">{{ index + 1 }}</td>
                        <td v-if="isColumnVisible('nombre')" class="p-3 w-30">{{ item.nombre }}</td>
                        <td v-if="isColumnVisible('ranking')" class="p-3 w-20 text-center">{{ item.ranking }}</td>
                        <td v-if="isColumnVisible('totalLecturas') && !tipo" class="p-3 w-20 text-center gap-1">
                            <div class="flex items-center justify-center gap-1">
                                <span>{{ item.totalLecturas }}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="size-5 text-gray-500">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                </svg>
                            </div>
                        </td>
                        <td v-if="isColumnVisible('totalEscuchas') && tipo" class="p-3 w-20 text-center gap-1">
                            <span>{{ item.totalEscuchas }}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="size-5 text-gray-500">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>
                        </td>
                        <td v-if="isColumnVisible('totalVotos')" class="p-3 w-20 text-center">
                            <span class="bg-blue-500 text-white font-medium rounded-full px-3 py-1">{{ item.totalVotos
                            }}</span>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr v-for="n in 5" :key="n" class="animate-pulse table-row">
                        <td v-if="isColumnVisible('posicionGlobal')" class="p-3 w-20">
                            <div class="h-6 bg-gray-200 rounded w-full"></div>
                        </td>
                        <td v-if="isColumnVisible('nombre')" class="p-3 w-30">
                            <div class="h-6 bg-gray-200 rounded w-full"></div>
                        </td>
                        <td v-if="isColumnVisible('ranking')" class="p-3 w-20 text-center">
                            <div class="h-6 bg-gray-200 rounded w-full mx-auto"></div>
                        </td>
                        <td v-if="isColumnVisible('totalLecturas') && !tipo" class="p-3 w-20 text-center">
                            <div class="h-6 bg-gray-200 rounded w-full mx-auto"></div>
                        </td>
                        <td v-if="isColumnVisible('totalEscuchas') && tipo" class="p-3 w-20 text-center">
                            <div class="h-6 bg-gray-200 rounded w-full mx-auto"></div>
                        </td>
                        <td v-if="isColumnVisible('totalVotos')" class="p-3 w-20 text-center">
                            <div class="h-6 bg-gray-200 rounded w-full mx-auto"></div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-4 flex justify-between items-center text-sm">
            <button @click="changePage(-1)" :disabled="page <= 1"
                class="text-gray-600 hover:text-blue-600 disabled:text-gray-300 transition">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                </svg>
            </button>
            <span>Página {{ page }}</span>
            <button @click="changePage(1)" class="text-gray-600 hover:text-blue-600 transition">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
const SERVER = 'https://staging-strapi.orsai.org';

export default {
    data() {
        return {
            data: [],
            order: 'ranking',
            orderDirection: 'DESC',
            page: 1,
            loading: false,
            forceRefreshFlag: false,
            showDropdown: false,
            visibleColumns: ['posicionGlobal', 'nombre', 'ranking', 'totalLecturas', 'totalEscuchas', 'totalVotos'],
            columnOptions: [
                { key: 'posicionGlobal', label: 'Posición' },
                { key: 'nombre', label: 'Nombre' },
                { key: 'ranking', label: 'Ranking' },
                { key: 'totalLecturas', label: 'Lecturas', show: () => !this.tipo },
                { key: 'totalEscuchas', label: 'Escuchas', show: () => this.tipo },
                { key: 'totalVotos', label: 'Votos' },
            ],
        };
    },
    computed: {
        tipo() {
            const urlParams = new URLSearchParams(window.location.search);
            return urlParams.get('tipo');
        },
        filteredColumnOptions() {
            return this.columnOptions.filter(col => !col.show || col.show());
        },
    },
    methods: {
        async fetchData() {
            this.loading = true;
            let ENDPOINT = `${SERVER}/api/cuentos/private-ranking?page=${this.page}&orderBy=${this.order}&orderDirection=${this.orderDirection}`;
            if (this.tipo) {
                ENDPOINT = `${SERVER}/api/cuentos/private-ranking-audio?page=${this.page}&orderBy=${this.order}&orderDirection=${this.orderDirection}`;
            }
            if (this.forceRefreshFlag) ENDPOINT += '&refresh=true';

            try {
                const response = await fetch(ENDPOINT);
                const result = await response.json();
                this.data = result.data || [];
            } catch (error) {
                console.error('Failed to fetch ranking data:', error);
            } finally {
                this.loading = false;
                this.forceRefreshFlag = false;
            }
        },
        toggleOrder(order) {
            this.page = 1;
            if (this.order === order) {
                this.orderDirection = this.orderDirection === 'ASC' ? 'DESC' : 'ASC';
            } else {
                this.order = order;
                this.orderDirection = 'DESC';
            }
            this.fetchData();
        },
        changePage(delta) {
            this.page += delta;
            this.fetchData();
        },
        forceRefresh() {
            this.forceRefreshFlag = true;
            this.fetchData();
        },
        isColumnVisible(key) {
            const option = this.columnOptions.find(opt => opt.key === key);
            return this.visibleColumns.includes(key) && (!option.show || option.show());
        },
        toggleColumn(key) {
            // Handled by v-model
        },
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
    },
    watch: {
        tipo() {
            this.fetchData();
        },
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style lang="scss">
table {

    th,
    td {
        min-width: 0;
        /* Allow columns to shrink if needed */
        padding: 0.75rem;
        border-bottom: 1px solid #e5e7eb;
        /* Add subtle border for separation */
    }

    td.div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 100%;
    }

    th {
        white-space: nowrap;
        background-color: #f3f4f6;
        position: sticky;
        top: 0;
        z-index: 10;
    }

    td {
        vertical-align: middle;
    }

    /* Fixed column widths */
    .w-20 {
        width: 20%;
        max-width: 120px;
        /* Prevent overly wide columns */
    }


    /* Prevent content overflow */
    th,
    td {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Ensure table cells don’t expand beyond their fixed widths */
    th div,
    td div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.copete {
    font-size: 1rem;
    line-height: 1.5;
}

/* Ensure consistent layout on all screens */
@media (min-width: 640px) {

    table th,
    table td {
        display: table-cell;
    }

    table tr {
        display: table-row;
    }
}

@media (max-width: 639px) {

    table th,
    table td {
        display: table-cell;
    }

    table tr {
        display: table-row;
    }

}
</style>